// // ============================================================
// // src/components/admin/HospitalSettingsTab.js
// // Admin can edit ALL hospital details from here
// // ============================================================
// import React, { useState, useEffect } from "react";
// import api from "../../utils/api";
// import { useHospital } from "../../context/HospitalContext";

// export default function HospitalSettingsTab({ showNotify }) {
//   const { hospital, refreshHospital } = useHospital();
//   const [saving, setSaving] = useState(false);
//   const [activeSection, setActiveSection] = useState("basic");

//   const [form, setForm] = useState({
//     // Basic
//     name: "",
//     tagline: "",
//     phone: "",
//     whatsapp: "",
//     email: "",
//     address: "",
//     city: "",
//     established: "",
//     description: "",
//     logoUrl: "",
//     // Hero stats
//     statPatients: "",
//     statDoctors: "",
//     statRating: "",
//     // Ticker
//     tickerItems: "",
//     // Why Us
//     whyUsTitle: "",
//     whyUsTagline: "",
//     whyUsDesc: "",
//     // Insurance
//     insuranceTitle: "",
//     insuranceDesc: "",
//     insurers: "",
//   });

//   const [whyFeatures, setWhyFeatures] = useState([]);
//   const [whyStats, setWhyStats] = useState([]);
//   const [testimonials, setTestimonials] = useState([]);

//   useEffect(() => {
//     if (hospital && hospital.name) {
//       setForm({
//         name: hospital.name || "",
//         tagline: hospital.tagline || "",
//         phone: hospital.phone || "",
//         whatsapp: hospital.whatsapp || "",
//         email: hospital.email || "",
//         address: hospital.address || "",
//         city: hospital.city || "",
//         established: hospital.established || "",
//         description: hospital.description || "",
//         logoUrl: hospital.logoUrl || "",
//         statPatients: hospital.statPatients || "18K+",
//         statDoctors: hospital.statDoctors || "20+",
//         statRating: hospital.statRating || "4.9★",
//         tickerItems: (hospital.tickerItems || []).join("\n"),
//         whyUsTitle: hospital.whyUsTitle || "",
//         whyUsTagline: hospital.whyUsTagline || "",
//         whyUsDesc: hospital.whyUsDesc || "",
//         insuranceTitle: hospital.insuranceTitle || "",
//         insuranceDesc: hospital.insuranceDesc || "",
//         insurers: (hospital.insurers || []).join("\n"),
//       });
//       setWhyFeatures(hospital.whyUsFeatures || []);
//       setWhyStats(hospital.whyUsStats || []);
//       setTestimonials(hospital.testimonials || []);
//     }
//   }, [hospital]);

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       showNotify("Error", "Hospital name is required.", true);
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = {
//         ...form,
//         tickerItems: form.tickerItems
//           .split("\n")
//           .map((s) => s.trim())
//           .filter(Boolean),
//         insurers: form.insurers
//           .split("\n")
//           .map((s) => s.trim())
//           .filter(Boolean),
//         whyUsFeatures: whyFeatures,
//         whyUsStats: whyStats,
//         testimonials,
//       };
//       // await api.put("/hospital", payload);
//       // refreshHospital();
//       // showNotify(
//       await api.put("/hospital", payload);
//       await refreshHospital();
//       showNotify(
//         "✅ Hospital Settings Saved!",
//         "All changes are now live on the website.",
//       );
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setSaving(false);
//   };

//   // ── Styles ──────────────────────────────────────────────────
//   const inp = {
//     width: "100%",
//     padding: "10px 14px",
//     borderRadius: 8,
//     border: "1.5px solid #e2e8f0",
//     fontSize: 14,
//     fontFamily: "DM Sans, sans-serif",
//     outline: "none",
//     background: "#f8fafc",
//     boxSizing: "border-box",
//     marginTop: 4,
//   };
//   const lbl = {
//     fontSize: 12,
//     fontWeight: 600,
//     color: "#475569",
//     display: "block",
//     marginBottom: 2,
//   };
//   const fwrap = { marginBottom: 16 };
//   const g2 = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 };
//   const g3 = { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 };

//   const sectionBtn = (id, label) => (
//     <button
//       onClick={() => setActiveSection(id)}
//       style={{
//         padding: "8px 16px",
//         borderRadius: 8,
//         border: "none",
//         cursor: "pointer",
//         fontSize: 13,
//         fontWeight: 600,
//         background: activeSection === id ? "#0d7377" : "#f1f5f9",
//         color: activeSection === id ? "#fff" : "#374151",
//         transition: "all 0.2s",
//       }}
//     >
//       {label}
//     </button>
//   );

//   return (
//     <div>
//       <div className="admin-section-title">🏥 Hospital Settings</div>
//       <div className="admin-section-desc">
//         Update your hospital details. Changes reflect instantly on the public
//         website.
//       </div>

//       {/* Section Navigation */}
//       <div
//         style={{
//           display: "flex",
//           gap: 8,
//           flexWrap: "wrap",
//           marginBottom: 24,
//           marginTop: 16,
//         }}
//       >
//         {sectionBtn("basic", "🏥 Basic Info")}
//         {sectionBtn("stats", "📊 Stats")}
//         {sectionBtn("ticker", "📢 Ticker")}
//         {sectionBtn("whyus", "💡 Why Us")}
//         {sectionBtn("testimonials", "⭐ Testimonials")}
//         {sectionBtn("insurance", "🏦 Insurance")}
//       </div>

//       <div style={{ maxWidth: 700 }}>
//         {/* ── BASIC INFO ──────────────────────────────────────── */}
//         {activeSection === "basic" && (
//           <div>
//             <div style={g2}>
//               <div style={fwrap}>
//                 <label style={lbl}>Hospital Name *</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="e.g. PearlSmile Dental Hospital"
//                   value={form.name}
//                   onChange={(e) => set("name", e.target.value)}
//                 />
//               </div>
//               <div style={fwrap}>
//                 <label style={lbl}>Tagline / Type</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="e.g. Dental Hospital"
//                   value={form.tagline}
//                   onChange={(e) => set("tagline", e.target.value)}
//                 />
//               </div>
//             </div>
//             <div style={g2}>
//               <div style={fwrap}>
//                 <label style={lbl}>Phone Number *</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="+91 87936 08083"
//                   value={form.phone}
//                   onChange={(e) => set("phone", e.target.value)}
//                 />
//               </div>
//               <div style={fwrap}>
//                 <label style={lbl}>
//                   WhatsApp{" "}
//                   <span style={{ fontWeight: 400, color: "#94a3b8" }}>
//                     (no + , with country code)
//                   </span>
//                 </label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="918793608083"
//                   value={form.whatsapp}
//                   onChange={(e) => set("whatsapp", e.target.value)}
//                 />
//               </div>
//             </div>
//             <div style={g2}>
//               <div style={fwrap}>
//                 <label style={lbl}>Email Address</label>
//                 <input
//                   style={inp}
//                   type="email"
//                   placeholder="care@hospital.in"
//                   value={form.email}
//                   onChange={(e) => set("email", e.target.value)}
//                 />
//               </div>
//               <div style={fwrap}>
//                 <label style={lbl}>Established Year</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="e.g. 2005"
//                   value={form.established}
//                   onChange={(e) => set("established", e.target.value)}
//                 />
//               </div>
//             </div>
//             <div style={g2}>
//               <div style={fwrap}>
//                 <label style={lbl}>Address</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="12, Dental Plaza, MG Road"
//                   value={form.address}
//                   onChange={(e) => set("address", e.target.value)}
//                 />
//               </div>
//               <div style={fwrap}>
//                 <label style={lbl}>City / State / Pincode</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="Pune, Maharashtra 411001"
//                   value={form.city}
//                   onChange={(e) => set("city", e.target.value)}
//                 />
//               </div>
//             </div>
//             <div style={fwrap}>
//               <label style={lbl}>
//                 Logo URL{" "}
//                 <span style={{ fontWeight: 400, color: "#94a3b8" }}>
//                   (paste image link or leave empty for 🦷)
//                 </span>
//               </label>
//               <input
//                 style={inp}
//                 type="url"
//                 placeholder="https://your-logo-url.com/logo.png"
//                 value={form.logoUrl}
//                 onChange={(e) => set("logoUrl", e.target.value)}
//               />
//               {form.logoUrl && (
//                 <img
//                   src={form.logoUrl}
//                   alt="Logo preview"
//                   onError={(e) => {
//                     e.target.style.display = "none";
//                   }}
//                   style={{
//                     marginTop: 8,
//                     width: 56,
//                     height: 56,
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                     border: "2px solid #e2e8f0",
//                   }}
//                 />
//               )}
//             </div>
//             <div style={fwrap}>
//               <label style={lbl}>
//                 Hospital Description{" "}
//                 <span style={{ fontWeight: 400, color: "#94a3b8" }}>
//                   (shown in footer)
//                 </span>
//               </label>
//               <textarea
//                 style={{ ...inp, minHeight: 80, resize: "vertical" }}
//                 placeholder="Brief description..."
//                 value={form.description}
//                 onChange={(e) => set("description", e.target.value)}
//               />
//             </div>
//           </div>
//         )}

//         {/* ── STATS ───────────────────────────────────────────── */}
//         {activeSection === "stats" && (
//           <div>
//             <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
//               These stats appear on the Hero section and Why Us section of the
//               main page.
//             </div>
//             <div style={g3}>
//               <div style={fwrap}>
//                 <label style={lbl}>Happy Patients</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="18K+"
//                   value={form.statPatients}
//                   onChange={(e) => set("statPatients", e.target.value)}
//                 />
//               </div>
//               <div style={fwrap}>
//                 <label style={lbl}>Expert Doctors</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="20+"
//                   value={form.statDoctors}
//                   onChange={(e) => set("statDoctors", e.target.value)}
//                 />
//               </div>
//               <div style={fwrap}>
//                 <label style={lbl}>Avg Rating</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="4.9★"
//                   value={form.statRating}
//                   onChange={(e) => set("statRating", e.target.value)}
//                 />
//               </div>
//             </div>

//             <div
//               style={{
//                 marginTop: 24,
//                 fontWeight: 700,
//                 fontSize: 13,
//                 color: "#0d7377",
//                 marginBottom: 12,
//               }}
//             >
//               Why Us Stats (4 cards)
//             </div>
//             {whyStats.map((s, i) => (
//               <div
//                 key={i}
//                 style={{
//                   display: "flex",
//                   gap: 10,
//                   marginBottom: 10,
//                   alignItems: "center",
//                 }}
//               >
//                 <input
//                   style={{ ...inp, marginTop: 0, flex: 1 }}
//                   placeholder="Number e.g. 18,000+"
//                   value={s.num}
//                   onChange={(e) => {
//                     const arr = [...whyStats];
//                     arr[i] = { ...arr[i], num: e.target.value };
//                     setWhyStats(arr);
//                   }}
//                 />
//                 <input
//                   style={{ ...inp, marginTop: 0, flex: 2 }}
//                   placeholder="Label e.g. Smiles Transformed"
//                   value={s.label}
//                   onChange={(e) => {
//                     const arr = [...whyStats];
//                     arr[i] = { ...arr[i], label: e.target.value };
//                     setWhyStats(arr);
//                   }}
//                 />
//                 <button
//                   onClick={() =>
//                     setWhyStats(whyStats.filter((_, j) => j !== i))
//                   }
//                   style={{
//                     background: "#fef2f2",
//                     border: "1px solid #fca5a5",
//                     color: "#dc2626",
//                     borderRadius: 6,
//                     padding: "6px 10px",
//                     cursor: "pointer",
//                     flexShrink: 0,
//                   }}
//                 >
//                   ✕
//                 </button>
//               </div>
//             ))}
//             <button
//               onClick={() => setWhyStats([...whyStats, { num: "", label: "" }])}
//               style={{
//                 background: "#f1f5f9",
//                 border: "1px solid #d1d5db",
//                 borderRadius: 8,
//                 padding: "8px 16px",
//                 fontSize: 13,
//                 cursor: "pointer",
//                 color: "#374151",
//               }}
//             >
//               + Add Stat
//             </button>
//           </div>
//         )}

//         {/* ── TICKER ──────────────────────────────────────────── */}
//         {activeSection === "ticker" && (
//           <div>
//             <div style={{ fontSize: 13, color: "#64748b", marginBottom: 12 }}>
//               These items scroll across the ticker bar. One item per line.
//             </div>
//             <div style={fwrap}>
//               <label style={lbl}>
//                 Ticker Items{" "}
//                 <span style={{ fontWeight: 400, color: "#94a3b8" }}>
//                   (one per line)
//                 </span>
//               </label>
//               <textarea
//                 style={{
//                   ...inp,
//                   minHeight: 200,
//                   resize: "vertical",
//                   fontFamily: "monospace",
//                 }}
//                 placeholder={
//                   "Painless Procedures\nCosmetic Dentistry\nAward-Winning Care"
//                 }
//                 value={form.tickerItems}
//                 onChange={(e) => set("tickerItems", e.target.value)}
//               />
//             </div>
//             <div style={{ fontSize: 12, color: "#94a3b8" }}>
//               💡 Tip: Keep items short (2-4 words each) for best display.
//             </div>
//           </div>
//         )}

//         {/* ── WHY US ──────────────────────────────────────────── */}
//         {activeSection === "whyus" && (
//           <div>
//             <div style={g2}>
//               <div style={fwrap}>
//                 <label style={lbl}>Section Tag</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="Why PearlSmile"
//                   value={form.whyUsTitle}
//                   onChange={(e) => set("whyUsTitle", e.target.value)}
//                 />
//               </div>
//               <div style={fwrap}>
//                 <label style={lbl}>Tagline</label>
//                 <input
//                   style={inp}
//                   type="text"
//                   placeholder="Care You Can Trust Completely"
//                   value={form.whyUsTagline}
//                   onChange={(e) => set("whyUsTagline", e.target.value)}
//                 />
//               </div>
//             </div>
//             <div style={fwrap}>
//               <label style={lbl}>Description</label>
//               <textarea
//                 style={{ ...inp, minHeight: 72, resize: "vertical" }}
//                 placeholder="We combine advanced technology..."
//                 value={form.whyUsDesc}
//                 onChange={(e) => set("whyUsDesc", e.target.value)}
//               />
//             </div>

//             <div
//               style={{
//                 fontWeight: 700,
//                 fontSize: 13,
//                 color: "#0d7377",
//                 margin: "16px 0 10px",
//               }}
//             >
//               Feature Items
//             </div>
//             {whyFeatures.map((f, i) => (
//               <div
//                 key={i}
//                 style={{
//                   background: "#f8fafc",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: 10,
//                   padding: 14,
//                   marginBottom: 12,
//                 }}
//               >
//                 <div style={{ display: "flex", gap: 10, marginBottom: 8 }}>
//                   <input
//                     style={{ ...inp, marginTop: 0, width: 60 }}
//                     placeholder="🏆"
//                     value={f.icon}
//                     onChange={(e) => {
//                       const arr = [...whyFeatures];
//                       arr[i] = { ...arr[i], icon: e.target.value };
//                       setWhyFeatures(arr);
//                     }}
//                   />
//                   <input
//                     style={{ ...inp, marginTop: 0, flex: 1 }}
//                     placeholder="Feature Title"
//                     value={f.title}
//                     onChange={(e) => {
//                       const arr = [...whyFeatures];
//                       arr[i] = { ...arr[i], title: e.target.value };
//                       setWhyFeatures(arr);
//                     }}
//                   />
//                   <button
//                     onClick={() =>
//                       setWhyFeatures(whyFeatures.filter((_, j) => j !== i))
//                     }
//                     style={{
//                       background: "#fef2f2",
//                       border: "1px solid #fca5a5",
//                       color: "#dc2626",
//                       borderRadius: 6,
//                       padding: "6px 10px",
//                       cursor: "pointer",
//                       flexShrink: 0,
//                     }}
//                   >
//                     ✕
//                   </button>
//                 </div>
//                 <textarea
//                   style={{
//                     ...inp,
//                     marginTop: 0,
//                     minHeight: 56,
//                     resize: "vertical",
//                   }}
//                   placeholder="Feature description..."
//                   value={f.desc}
//                   onChange={(e) => {
//                     const arr = [...whyFeatures];
//                     arr[i] = { ...arr[i], desc: e.target.value };
//                     setWhyFeatures(arr);
//                   }}
//                 />
//               </div>
//             ))}
//             <button
//               onClick={() =>
//                 setWhyFeatures([
//                   ...whyFeatures,
//                   { icon: "", title: "", desc: "" },
//                 ])
//               }
//               style={{
//                 background: "#f1f5f9",
//                 border: "1px solid #d1d5db",
//                 borderRadius: 8,
//                 padding: "8px 16px",
//                 fontSize: 13,
//                 cursor: "pointer",
//                 color: "#374151",
//               }}
//             >
//               + Add Feature
//             </button>
//           </div>
//         )}

//         {/* ── TESTIMONIALS ────────────────────────────────────── */}
//         {activeSection === "testimonials" && (
//           <div>
//             <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
//               Manage patient reviews shown on the main page.
//             </div>
//             {testimonials.map((t, i) => (
//               <div
//                 key={i}
//                 style={{
//                   background: "#f8fafc",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: 10,
//                   padding: 14,
//                   marginBottom: 12,
//                 }}
//               >
//                 <div style={{ display: "flex", gap: 10, marginBottom: 8 }}>
//                   <input
//                     style={{ ...inp, marginTop: 0, width: 60 }}
//                     placeholder="A"
//                     value={t.init}
//                     onChange={(e) => {
//                       const arr = [...testimonials];
//                       arr[i] = { ...arr[i], init: e.target.value };
//                       setTestimonials(arr);
//                     }}
//                   />
//                   <input
//                     style={{ ...inp, marginTop: 0, flex: 1 }}
//                     placeholder="Patient Name"
//                     value={t.name}
//                     onChange={(e) => {
//                       const arr = [...testimonials];
//                       arr[i] = { ...arr[i], name: e.target.value };
//                       setTestimonials(arr);
//                     }}
//                   />
//                   <button
//                     onClick={() =>
//                       setTestimonials(testimonials.filter((_, j) => j !== i))
//                     }
//                     style={{
//                       background: "#fef2f2",
//                       border: "1px solid #fca5a5",
//                       color: "#dc2626",
//                       borderRadius: 6,
//                       padding: "6px 10px",
//                       cursor: "pointer",
//                       flexShrink: 0,
//                     }}
//                   >
//                     ✕
//                   </button>
//                 </div>
//                 <input
//                   style={{ ...inp, marginTop: 0, marginBottom: 8 }}
//                   placeholder="Role e.g. Software Engineer, Pune"
//                   value={t.role}
//                   onChange={(e) => {
//                     const arr = [...testimonials];
//                     arr[i] = { ...arr[i], role: e.target.value };
//                     setTestimonials(arr);
//                   }}
//                 />
//                 <textarea
//                   style={{
//                     ...inp,
//                     marginTop: 0,
//                     minHeight: 72,
//                     resize: "vertical",
//                   }}
//                   placeholder="Patient review..."
//                   value={t.quote}
//                   onChange={(e) => {
//                     const arr = [...testimonials];
//                     arr[i] = { ...arr[i], quote: e.target.value };
//                     setTestimonials(arr);
//                   }}
//                 />
//               </div>
//             ))}
//             <button
//               onClick={() =>
//                 setTestimonials([
//                   ...testimonials,
//                   { init: "", name: "", role: "", quote: "", stars: "★★★★★" },
//                 ])
//               }
//               style={{
//                 background: "#f1f5f9",
//                 border: "1px solid #d1d5db",
//                 borderRadius: 8,
//                 padding: "8px 16px",
//                 fontSize: 13,
//                 cursor: "pointer",
//                 color: "#374151",
//               }}
//             >
//               + Add Review
//             </button>
//           </div>
//         )}

//         {/* ── INSURANCE ───────────────────────────────────────── */}
//         {activeSection === "insurance" && (
//           <div>
//             <div style={fwrap}>
//               <label style={lbl}>Section Title</label>
//               <input
//                 style={inp}
//                 type="text"
//                 placeholder="We Accept All Major Insurance Plans"
//                 value={form.insuranceTitle}
//                 onChange={(e) => set("insuranceTitle", e.target.value)}
//               />
//             </div>
//             <div style={fwrap}>
//               <label style={lbl}>Description</label>
//               <textarea
//                 style={{ ...inp, minHeight: 72, resize: "vertical" }}
//                 placeholder="Cashless treatment available..."
//                 value={form.insuranceDesc}
//                 onChange={(e) => set("insuranceDesc", e.target.value)}
//               />
//             </div>
//             <div style={fwrap}>
//               <label style={lbl}>
//                 Insurance Companies{" "}
//                 <span style={{ fontWeight: 400, color: "#94a3b8" }}>
//                   (one per line)
//                 </span>
//               </label>
//               <textarea
//                 style={{
//                   ...inp,
//                   minHeight: 160,
//                   resize: "vertical",
//                   fontFamily: "monospace",
//                 }}
//                 placeholder={"Star Health\nNew India\nHDFC ERGO\nICICI Lombard"}
//                 value={form.insurers}
//                 onChange={(e) => set("insurers", e.target.value)}
//               />
//             </div>
//           </div>
//         )}

//         {/* Save Button */}
//         <div
//           style={{
//             marginTop: 24,
//             display: "flex",
//             alignItems: "center",
//             gap: 16,
//           }}
//         >
//           <button
//             onClick={handleSave}
//             disabled={saving}
//             style={{
//               background: saving
//                 ? "#94a3b8"
//                 : "linear-gradient(135deg,#0d7377,#14a0a5)",
//               color: "#fff",
//               border: "none",
//               borderRadius: 10,
//               padding: "13px 32px",
//               fontSize: 14,
//               fontWeight: 700,
//               cursor: saving ? "not-allowed" : "pointer",
//               fontFamily: "DM Sans, sans-serif",
//               transition: "opacity 0.2s",
//             }}
//           >
//             {saving ? "Saving..." : "💾 Save Hospital Settings"}
//           </button>
//           <div style={{ fontSize: 11, color: "#94a3b8" }}>
//             ✅ Changes reflect instantly on website — no rebuild needed.
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

////////////// google link check/////////////
// ============================================================
// src/components/admin/HospitalSettingsTab.js
// ✅ All previous fixes kept
// ✅ Stats defaults by hospital type
// ✅ Ticker defaults by hospital type
// ============================================================
import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import { useHospital } from "../../context/HospitalContext";
import { getSpecialtyText } from "../../utils/specialtyText";

// ✅ Why Us Stats defaults by hospital type
const DEFAULT_WHY_STATS = {
  dental: [
    { num: "18,000+", label: "Smiles Transformed" },
    { num: "20+", label: "Specialist Doctors" },
    { num: "4.9★", label: "Average Patient Rating" },
    { num: "98%", label: "Would Recommend Us" },
  ],
  ayurved: [
    { num: "25,000+", label: "Lives Healed Naturally" },
    { num: "50+", label: "Certified Vaidyas & Therapists" },
    { num: "4.9★", label: "Average Patient Rating" },
    { num: "96%", label: "Patients Recommend Us" },
  ],
  ortho: [
    { num: "30,000+", label: "Surgeries Performed" },
    { num: "40+", label: "Orthopedic Specialists" },
    { num: "4.8★", label: "Average Patient Rating" },
    { num: "97%", label: "Pain-Free After Treatment" },
  ],
  eye: [
    { num: "50,000+", label: "Eyes Treated Successfully" },
    { num: "30+", label: "Expert Ophthalmologists" },
    { num: "4.9★", label: "Average Patient Rating" },
    { num: "99%", label: "LASIK Success Rate" },
  ],
  cardiology: [
    { num: "20,000+", label: "Cardiac Procedures Done" },
    { num: "25+", label: "Senior Cardiologists" },
    { num: "4.8★", label: "Average Patient Rating" },
    { num: "98%", label: "Patients Recovered Successfully" },
  ],
  pediatric: [
    { num: "35,000+", label: "Children Treated" },
    { num: "45+", label: "Pediatric Specialists" },
    { num: "4.9★", label: "Average Patient Rating" },
    { num: "97%", label: "Parents Recommend Us" },
  ],
  general: [
    { num: "1,00,000+", label: "Patients Treated" },
    { num: "100+", label: "Specialist Doctors" },
    { num: "4.8★", label: "Average Patient Rating" },
    { num: "98%", label: "Would Recommend Us" },
  ],
};

// ✅ Ticker defaults by hospital type
const DEFAULT_TICKER = {
  dental: [
    "Painless Procedures",
    "Cosmetic Dentistry",
    "Award-Winning Care",
    "Same-Day Appointments",
    "All Insurance Accepted",
    "20+ Years Experience",
    "Advanced Anesthesia",
    "State-of-the-Art Facility",
  ],
  ayurved: [
    "100% Natural Treatments",
    "Herbal Skin & Beauty Care",
    "Nationally Recognized Wellness Center",
    "Flexible Consultation Slots",
    "Affordable Wellness Packages",
    "20+ Years of Ayurvedic Practice",
    "Dosha-Based Personalized Therapy",
    "Authentic Panchakarma Center",
  ],
  ortho: [
    "Minimally Invasive Surgeries",
    "Sports Injury Rehabilitation",
    "Award-Winning Surgical Team",
    "Same-Day OPD Consultations",
    "All Insurance & Cashless Accepted",
    "20+ Years Surgical Excellence",
    "Advanced Pain Management",
    "Fully Equipped Surgical OT",
  ],
  eye: [
    "Bladeless & Painless Surgeries",
    "Oculoplasty & Cosmetic Eye Care",
    "Award-Winning Eye Care Center",
    "Same-Day Eye Checkups",
    "All Insurance & Cashless Accepted",
    "20+ Years in Ophthalmology",
    "Topical Anesthesia Technology",
    "Advanced Laser & Imaging Center",
  ],
  cardiology: [
    "Minimally Invasive Cardiac Procedures",
    "Preventive Heart Care Programs",
    "Award-Winning Cardiac Center",
    "Emergency & Same-Day Consultations",
    "All Insurance & Cashless Accepted",
    "20+ Years of Cardiac Excellence",
    "Advanced Cardiac Anesthesia",
    "Cath Lab & Advanced Cardiac ICU",
  ],
  pediatric: [
    "Gentle & Child-Friendly Procedures",
    "Child Growth & Nutrition Counseling",
    "Award-Winning Children's Hospital",
    "Same-Day Pediatric Consultations",
    "All Insurance & Cashless Accepted",
    "20+ Years Caring for Children",
    "Safe Pediatric Anesthesia",
    "Child-Safe & Friendly Environment",
  ],
  general: [
    "Minimally Invasive Procedures",
    "Multi-Specialty Departments",
    "NABH Accredited Hospital",
    "Same-Day OPD & Consultations",
    "All Insurance & Cashless Accepted",
    "20+ Years of Medical Excellence",
    "Advanced ICU & Critical Care",
    "Fully Equipped Multi-Specialty Facility",
  ],
};

// ✅ Why Us text defaults by hospital type (from specialtyText)
const DEFAULT_WHY_US = {
  dental: {
    title: "Why PearlSmile",
    tagline: "Care You Can Trust Completely",
    desc: "We combine advanced technology with genuine compassion, ensuring every visit is comfortable, efficient, and stress-free.",
  },
  ayurved: {
    title: "Why Choose Us",
    tagline: "Healing You Can Trust Completely",
    desc: "We combine ancient Ayurvedic wisdom with modern wellness science, ensuring every therapy restores your body, mind, and spirit.",
  },
  ortho: {
    title: "Why Choose Us",
    tagline: "Mobility You Can Trust Completely",
    desc: "We combine advanced surgical expertise with personalised rehabilitation, ensuring every patient regains strength and lives pain-free.",
  },
  eye: {
    title: "Why Choose Us",
    tagline: "Vision You Can Trust Completely",
    desc: "We combine cutting-edge optical technology with expert surgical care, ensuring every patient sees the world with clarity and confidence.",
  },
  cardiology: {
    title: "Why Choose Us",
    tagline: "Heart Care You Can Trust Completely",
    desc: "We combine world-class cardiac expertise with compassionate care, ensuring every heartbeat is protected with precision and dedication.",
  },
  pediatric: {
    title: "Why Choose Us",
    tagline: "Child Care You Can Trust Completely",
    desc: "We combine expert pediatric medicine with a child-friendly approach, ensuring every child receives gentle, compassionate, and effective healthcare.",
  },
  general: {
    title: "Why Choose Us",
    tagline: "Healthcare You Can Trust Completely",
    desc: "We combine multi-specialty medical expertise with compassionate patient care, ensuring every patient receives the right treatment under one roof.",
  },
};

// ✅ Default features by hospital type
const DEFAULT_FEATURES_BY_TYPE = {
  dental: [
    {
      icon: "🏆",
      title: "Award-Winning Specialists",
      desc: "Our team of 20+ specialists hold advanced certifications from top dental institutes and international bodies.",
    },
    {
      icon: "🤖",
      title: "Latest Technology",
      desc: "3D X-rays, digital impressions, laser dentistry, and same-day crowns using our in-house CEREC system.",
    },
    {
      icon: "😌",
      title: "Pain-Free Guarantee",
      desc: "Advanced sedation options and gentle techniques ensure you never feel a thing. Zero-anxiety dentistry.",
    },
    {
      icon: "⏰",
      title: "Same-Day Appointments",
      desc: "Emergency dental care available 7 days a week. Walk-ins welcome. No waiting for weeks.",
    },
  ],
  ayurved: [
    {
      icon: "🌿",
      title: "100% Natural Treatments",
      desc: "All therapies use authentic Ayurvedic herbs, oils, and techniques — no chemicals, no side effects.",
    },
    {
      icon: "✨",
      title: "Herbal Skin & Beauty Care",
      desc: "Traditional Ayurvedic beauty treatments for glowing skin and natural rejuvenation.",
    },
    {
      icon: "🏅",
      title: "Nationally Recognized Wellness Center",
      desc: "Certified by leading Ayurveda boards with decades of trusted healing practice.",
    },
    {
      icon: "🤲",
      title: "Dosha-Based Personalized Therapy",
      desc: "Every treatment is tailored to your unique body constitution for deep, lasting healing.",
    },
  ],
  ortho: [
    {
      icon: "🔬",
      title: "Minimally Invasive Surgeries",
      desc: "Advanced arthroscopic and keyhole techniques for faster recovery and minimal scarring.",
    },
    {
      icon: "🏃",
      title: "Sports Injury Rehabilitation",
      desc: "Comprehensive rehab programs designed by sports medicine experts to get you back on track.",
    },
    {
      icon: "🏆",
      title: "Award-Winning Surgical Team",
      desc: "Our orthopedic surgeons are recognized nationally for excellence in joint and spine surgery.",
    },
    {
      icon: "💊",
      title: "Advanced Pain Management",
      desc: "Multimodal pain management protocols ensuring comfort before, during, and after surgery.",
    },
  ],
  eye: [
    {
      icon: "👁️",
      title: "Bladeless & Painless Surgeries",
      desc: "Latest LASIK and cataract techniques using femtosecond laser for precision and zero discomfort.",
    },
    {
      icon: "✨",
      title: "Oculoplasty & Cosmetic Eye Care",
      desc: "Expert cosmetic and reconstructive eye procedures for appearance and function.",
    },
    {
      icon: "🏆",
      title: "Award-Winning Eye Care Center",
      desc: "Recognized for excellence in ophthalmology with thousands of successful surgeries annually.",
    },
    {
      icon: "🔬",
      title: "Advanced Laser & Imaging Center",
      desc: "State-of-the-art OCT, fundus photography, and laser systems for precise diagnosis and treatment.",
    },
  ],
  cardiology: [
    {
      icon: "❤️",
      title: "Minimally Invasive Cardiac Procedures",
      desc: "Cutting-edge catheterization and stenting techniques with minimal recovery time.",
    },
    {
      icon: "🛡️",
      title: "Preventive Heart Care Programs",
      desc: "Comprehensive cardiac risk assessment, lifestyle counseling, and early intervention programs.",
    },
    {
      icon: "🏆",
      title: "Award-Winning Cardiac Center",
      desc: "Nationally accredited cardiac care with industry-leading outcomes and patient satisfaction.",
    },
    {
      icon: "🏥",
      title: "Cath Lab & Advanced Cardiac ICU",
      desc: "24/7 fully equipped catheterization lab and cardiac intensive care unit for critical cases.",
    },
  ],
  pediatric: [
    {
      icon: "👶",
      title: "Gentle & Child-Friendly Procedures",
      desc: "Every procedure is designed to minimize discomfort with child-specific anesthesia and care protocols.",
    },
    {
      icon: "📈",
      title: "Child Growth & Nutrition Counseling",
      desc: "Expert guidance on age-appropriate nutrition, developmental milestones, and healthy growth.",
    },
    {
      icon: "🏆",
      title: "Award-Winning Children's Hospital",
      desc: "Trusted by thousands of families for compassionate, expert pediatric care.",
    },
    {
      icon: "🌈",
      title: "Child-Safe & Friendly Environment",
      desc: "Our hospital is designed specifically for children — colorful, safe, and anxiety-free.",
    },
  ],
  general: [
    {
      icon: "🏥",
      title: "Multi-Specialty Departments",
      desc: "All major specialties under one roof — cardiology, orthopedics, gynecology, ENT, and more.",
    },
    {
      icon: "🏅",
      title: "NABH Accredited Hospital",
      desc: "Nationally accredited for quality, safety, and patient-centered care standards.",
    },
    {
      icon: "🚑",
      title: "Advanced ICU & Critical Care",
      desc: "24/7 ICU with ventilators, monitors, and critical care specialists always on standby.",
    },
    {
      icon: "🔬",
      title: "Fully Equipped Multi-Specialty Facility",
      desc: "State-of-the-art diagnostics, OT, and imaging — everything needed for complete healthcare.",
    },
  ],
};

// ✅ Dental default feature titles to detect stale data
const DENTAL_FEATURE_TITLES = [
  "Award-Winning Specialists",
  "Latest Technology",
  "Pain-Free Guarantee",
  "Same-Day Appointments",
];

// ✅ Dental testimonial names — detect stale dental data in non-dental hospitals
const DENTAL_TESTIMONIAL_NAMES = [
  "Aisha Mehta",
  "Raj Patel",
  "Sunita Krishnan",
  "Mohammed Qureshi",
  "Preeti Sharma",
  "Vikram Iyer",
];

const SPECIALTY_TESTIMONIALS_BY_TYPE = {
  dental: [
    {
      init: "A",
      name: "Aisha Mehta",
      role: "Software Engineer, Pune",
      stars: "★★★★★",
      quote:
        "Dr. Sharma's implant work is absolutely outstanding. I can't believe how natural my new tooth feels — zero pain and completed in just two visits.",
    },
    {
      init: "R",
      name: "Raj Patel",
      role: "Business Owner, Mumbai",
      stars: "★★★★★",
      quote:
        "The smile makeover transformed my confidence completely. Dr. Priya's artistry with veneers is incredible — every detail is perfect.",
    },
    {
      init: "S",
      name: "Sunita Krishnan",
      role: "School Teacher, Pune",
      stars: "★★★★★",
      quote:
        "Took my 5-year-old to the kids' suite and she actually enjoyed her first dental visit! The team was incredibly patient and gentle.",
    },
    {
      init: "M",
      name: "Mohammed Qureshi",
      role: "CA, Pune",
      stars: "★★★★★",
      quote:
        "Invisalign results exceeded my expectations. Dr. Rahul monitored every step. My teeth are perfectly aligned in under 14 months!",
    },
    {
      init: "P",
      name: "Preeti Sharma",
      role: "Homemaker, Nashik",
      stars: "★★★★★",
      quote:
        "Root canal with zero pain? I didn't believe it until it happened. The anaesthesia was so effective I barely felt anything. Highly recommend!",
    },
    {
      init: "V",
      name: "Vikram Iyer",
      role: "Marketing Manager, Pune",
      stars: "★★★★★",
      quote:
        "Premium experience from start to finish. Clean, modern, professional. The digital X-rays and 3D scans gave me full confidence in the diagnosis.",
    },
  ],
  ayurved: [
    {
      init: "A",
      name: "Ananya Joshi",
      role: "Yoga Instructor, Pune",
      stars: "★★★★★",
      quote:
        "After years of chronic back pain, 14 days of Panchakarma gave me more relief than anything else I'd tried. My energy levels have completely transformed.",
    },
    {
      init: "R",
      name: "Ramesh Kulkarni",
      role: "Retired Professor, Pune",
      stars: "★★★★★",
      quote:
        "The Vaidya took an hour for my first consultation — understanding my constitution deeply before prescribing anything. That level of care is rare today.",
    },
    {
      init: "S",
      name: "Sneha Deshmukh",
      role: "Homemaker, Nashik",
      stars: "★★★★★",
      quote:
        "My digestion issues of 8 years were resolved in 3 weeks with a customised diet and herbal medicines. I wish I'd come here sooner.",
    },
    {
      init: "M",
      name: "Mihir Shah",
      role: "IT Professional, Pune",
      stars: "★★★★★",
      quote:
        "The Shirodhara session was the most deeply relaxing experience of my life. I sleep better than I have in a decade.",
    },
    {
      init: "P",
      name: "Padma Iyer",
      role: "School Principal, Mumbai",
      stars: "★★★★★",
      quote:
        "Classical authentic Ayurveda — not the spa version. The therapists are well-trained and genuinely knowledgeable. Results speak for themselves.",
    },
    {
      init: "V",
      name: "Vaishali Patil",
      role: "Entrepreneur, Pune",
      stars: "★★★★★",
      quote:
        "Came for stress and anxiety management. The combination of Abhyanga, Pranayama guidance, and herbal medicines has genuinely changed my quality of life.",
    },
  ],
  ortho: [
    {
      init: "A",
      name: "Arun Khanna",
      role: "Retired Army Officer, Pune",
      stars: "★★★★★",
      quote:
        "After my knee replacement I was walking in the corridor the very next morning. The physio team's support made recovery seamless.",
    },
    {
      init: "R",
      name: "Rekha Mehta",
      role: "Teacher, Mumbai",
      stars: "★★★★★",
      quote:
        "I was told elsewhere I needed open surgery for my shoulder. Here, the arthroscopic procedure had me back to teaching in 3 weeks. Life-changing.",
    },
    {
      init: "S",
      name: "Saurabh Desai",
      role: "Cricketer, Nashik",
      stars: "★★★★★",
      quote:
        "ACL reconstruction done with minimal scarring. I was back on the cricket field in 6 months — ahead of schedule. Outstanding sports injury expertise.",
    },
    {
      init: "M",
      name: "Meenakshi Pillai",
      role: "Homemaker, Pune",
      stars: "★★★★★",
      quote:
        "15 years of hip pain — gone after surgery. I can now take evening walks again.",
    },
    {
      init: "P",
      name: "Prashant Sawant",
      role: "Construction Engineer, Pune",
      stars: "★★★★★",
      quote:
        "Fractured both wrists in a site accident. The surgical team worked overnight to ensure my hands functioned perfectly. Incredible dedication.",
    },
    {
      init: "V",
      name: "Varsha Kulkarni",
      role: "Software Manager, Pune",
      stars: "★★★★★",
      quote:
        "Spine surgery was something I feared for years. The team's calm explanation and post-op rehab made the entire journey manageable.",
    },
  ],
  eye: [
    {
      init: "A",
      name: "Aarav Gupta",
      role: "Software Developer, Pune",
      stars: "★★★★★",
      quote:
        "LASIK done in under 10 minutes. Next morning I woke up with 6/6 vision for the first time in 15 years. I literally cried. Thank you!",
    },
    {
      init: "R",
      name: "Radha Krishnan",
      role: "Homemaker, Chennai",
      stars: "★★★★★",
      quote:
        "My mother's cataract surgery was completed in 15 minutes and she was home by afternoon. The very next morning she could read the newspaper unaided.",
    },
    {
      init: "S",
      name: "Shweta Patil",
      role: "School Teacher, Pune",
      stars: "★★★★★",
      quote:
        "Detected my child's squint early thanks to a school camp recommendation. The vision therapy has corrected it completely. Early detection is everything.",
    },
    {
      init: "M",
      name: "Manish Tiwari",
      role: "Banker, Mumbai",
      stars: "★★★★★",
      quote:
        "The pre-LASIK evaluation was thorough and honest. The procedure itself was painless and results are perfect.",
    },
    {
      init: "P",
      name: "Priya Nair",
      role: "Architect, Pune",
      stars: "★★★★★",
      quote:
        "Diabetic retinopathy management has been excellent. My vision has been preserved for 3 years now.",
    },
    {
      init: "V",
      name: "Vijay Anand",
      role: "Retired IAS Officer, Pune",
      stars: "★★★★★",
      quote:
        "At 72, I was nervous about cataract surgery. The doctor's patience and the zero-stitch procedure made it a very positive experience.",
    },
  ],
  cardiology: [
    {
      init: "A",
      name: "Ajay Verma",
      role: "Businessman, Pune",
      stars: "★★★★★",
      quote:
        "Came in with severe chest pain at 2 AM. Within 90 minutes I was in the cath lab and the blockage was cleared. The team literally saved my life that night.",
    },
    {
      init: "R",
      name: "Ranjana Bhosale",
      role: "Homemaker, Nashik",
      stars: "★★★★★",
      quote:
        "My husband's triple bypass was performed flawlessly. He was walking in the ICU corridor on day 2. The cardiac rehab team's follow-up has been outstanding.",
    },
    {
      init: "S",
      name: "Suresh Gokhale",
      role: "Retired Teacher, Pune",
      stars: "★★★★★",
      quote:
        "Pacemaker implantation done under local anaesthesia. I was discharged the next day and back to my morning walks within a week. Incredible modern medicine.",
    },
    {
      init: "M",
      name: "Madhuri Joshi",
      role: "IT Manager, Pune",
      stars: "★★★★★",
      quote:
        "My preventive cardiac check-up detected a significant blockage. Angioplasty done immediately — I feel I've been given a second life.",
    },
    {
      init: "P",
      name: "Prakash Shetty",
      role: "Hotelier, Goa",
      stars: "★★★★★",
      quote:
        "Flew from Goa for the valve replacement procedure. Worth every kilometer. The cardiac surgery team's expertise and the post-op ICU care were world-class.",
    },
    {
      init: "V",
      name: "Vandana Iyer",
      role: "Gynaecologist, Pune",
      stars: "★★★★★",
      quote:
        "As a doctor myself, I am extremely particular. This team's protocols, hygiene standards, and patient communication are the best I have encountered anywhere.",
    },
  ],
  pediatric: [
    {
      init: "A",
      name: "Anjali Mehra",
      role: "Mother of 2, Pune",
      stars: "★★★★★",
      quote:
        "My toddler was terrified of hospitals. The paediatric team spent 10 minutes just playing with him before the examination. He left asking to come back!",
    },
    {
      init: "R",
      name: "Rohit Sharma",
      role: "Father, Mumbai",
      stars: "★★★★★",
      quote:
        "Our premature baby (28 weeks) spent 6 weeks in the NICU here. The neonatology team's round-the-clock care was exceptional. He's thriving now.",
    },
    {
      init: "S",
      name: "Sunita Rao",
      role: "Mother, Hyderabad",
      stars: "★★★★★",
      quote:
        "Travelled from Hyderabad for my daughter's complex cardiac surgery. The paediatric cardiac team's expertise gave us our daughter back. Forever grateful.",
    },
    {
      init: "M",
      name: "Meera Pillai",
      role: "Software Engineer & Mom, Pune",
      stars: "★★★★★",
      quote:
        "Our son has been seen here from age 3 months to now age 7. The continuity of care and milestone monitoring — everything is seamless.",
    },
    {
      init: "P",
      name: "Parag Kulkarni",
      role: "Father, Nashik",
      stars: "★★★★★",
      quote:
        "My son's asthma has been so well managed that he hasn't had a single hospital admission in 2 years. The action plan the doctor gave us transformed our lives.",
    },
    {
      init: "V",
      name: "Vrinda Goyal",
      role: "Mother of Twins, Pune",
      stars: "★★★★★",
      quote:
        "Managing twin toddlers through their vaccination schedule was made easy with appointment reminders and a genuinely patient team.",
    },
  ],
  general: [
    {
      init: "A",
      name: "Aditya Mehta",
      role: "IT Professional, Pune",
      stars: "★★★★★",
      quote:
        "Had my full health check-up done here. Results were explained in detail. The doctor spent time discussing lifestyle changes. Truly comprehensive care.",
    },
    {
      init: "R",
      name: "Rekha Patil",
      role: "Homemaker, Nashik",
      stars: "★★★★★",
      quote:
        "Emergency appendix surgery at midnight — the team was ready and calm. Discharged in 2 days with complete instructions and a follow-up call. Outstanding service.",
    },
    {
      init: "S",
      name: "Suhas Joshi",
      role: "Retired Engineer, Pune",
      stars: "★★★★★",
      quote:
        "Needed to see three specialists in one visit. One hospital, one afternoon, complete coordination. Very impressive.",
    },
    {
      init: "M",
      name: "Manasi Deshpande",
      role: "Advocate, Pune",
      stars: "★★★★★",
      quote:
        "The reports portal is excellent — all my records in one place. More importantly, the doctors actually read the history before the consultation.",
    },
    {
      init: "P",
      name: "Pradeep Kumar",
      role: "Farmer, Satara",
      stars: "★★★★★",
      quote:
        "The Marathi-speaking staff helped bridge the language gap completely. Affordable, dignified, and truly patient-first care. Highly recommended.",
    },
    {
      init: "V",
      name: "Varsha Singh",
      role: "Pharmacist, Pune",
      stars: "★★★★★",
      quote:
        "As a healthcare professional I have high standards. The infection control and discharge counselling here match international benchmarks.",
    },
  ],
};

// ✅ Dental defaults to detect stale data
const DENTAL_WHY_TITLE = "Why PearlSmile";
const DENTAL_WHY_TAGLINE = "Care You Can Trust Completely";
const DENTAL_WHY_DESC =
  "We combine advanced technology with genuine compassion, ensuring every visit is comfortable, efficient, and stress-free.";

export default function HospitalSettingsTab({ showNotify }) {
  const { hospital, refreshHospital } = useHospital();
  const [saving, setSaving] = useState(false);
  const [activeSection, setActiveSection] = useState("basic");

  const [form, setForm] = useState({
    name: "",
    tagline: "",
    phone: "",
    whatsapp: "",
    email: "",
    address: "",
    city: "",
    established: "",
    description: "",
    logoUrl: "",
    googleMapsUrl: "",
    statPatients: "",
    statDoctors: "",
    statRating: "",
    tickerItems: "",
    whyUsTitle: "",
    whyUsTagline: "",
    whyUsDesc: "",
    insuranceTitle: "",
    insuranceDesc: "",
    insurers: "",
  });

  const [whyFeatures, setWhyFeatures] = useState([]);
  const [whyStats, setWhyStats] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    if (hospital && hospital.name) {
      const type = (hospital.type || "dental").toLowerCase();

      // ✅ Dental defaults — if DB has these, override with type-specific defaults
      const DENTAL_DEFAULT_TICKER = DEFAULT_TICKER.dental;
      const DENTAL_DEFAULT_STATS = DEFAULT_WHY_STATS.dental;

      const savedTicker = hospital.tickerItems || [];
      const defaultTicker = DEFAULT_TICKER[type] || DEFAULT_TICKER.dental;
      // Use type default if: empty OR still has dental defaults (for non-dental hospitals)
      const tickerIsDentalDefault =
        savedTicker.length > 0 &&
        DENTAL_DEFAULT_TICKER.every((item) => savedTicker.includes(item));
      const tickerToUse =
        savedTicker.length === 0 || (type !== "dental" && tickerIsDentalDefault)
          ? defaultTicker
          : savedTicker;

      const savedStats = hospital.whyUsStats || [];
      const defaultStats = DEFAULT_WHY_STATS[type] || DEFAULT_WHY_STATS.dental;
      // Use type default if: empty OR still has dental defaults (for non-dental hospitals)
      const statsIsDentalDefault =
        savedStats.length > 0 &&
        DENTAL_DEFAULT_STATS.every((d) =>
          savedStats.some((s) => s.num === d.num && s.label === d.label),
        );
      const statsToUse =
        savedStats.length === 0 || (type !== "dental" && statsIsDentalDefault)
          ? defaultStats
          : savedStats;

      setForm({
        name: hospital.name || "",
        tagline: hospital.tagline || "",
        phone: hospital.phone || "",
        whatsapp: hospital.whatsapp || "",
        email: hospital.email || "",
        address: hospital.address || "",
        city: hospital.city || "",
        established: hospital.established || "",
        description: hospital.description || "",
        logoUrl: hospital.logoUrl || "",
        googleMapsUrl: hospital.googleMapsUrl || "",
        statPatients: hospital.statPatients || "18K+",
        statDoctors: hospital.statDoctors || "20+",
        statRating: hospital.statRating || "4.9★",
        tickerItems: tickerToUse.join("\n"),
        // ✅ Use type-specific defaults if value is empty OR still has dental default
        whyUsTitle:
          hospital.whyUsTitle &&
          (type === "dental" || hospital.whyUsTitle !== DENTAL_WHY_TITLE)
            ? hospital.whyUsTitle
            : (DEFAULT_WHY_US[type] || DEFAULT_WHY_US.dental).title,
        whyUsTagline:
          hospital.whyUsTagline &&
          (type === "dental" || hospital.whyUsTagline !== DENTAL_WHY_TAGLINE)
            ? hospital.whyUsTagline
            : (DEFAULT_WHY_US[type] || DEFAULT_WHY_US.dental).tagline,
        whyUsDesc:
          hospital.whyUsDesc &&
          (type === "dental" || hospital.whyUsDesc !== DENTAL_WHY_DESC)
            ? hospital.whyUsDesc
            : (DEFAULT_WHY_US[type] || DEFAULT_WHY_US.dental).desc,
        insuranceTitle: hospital.insuranceTitle || "",
        insuranceDesc: hospital.insuranceDesc || "",
        insurers: (hospital.insurers || []).join("\n"),
      });
      // ✅ Use type-specific defaults if non-dental hospital has dental features
      const savedFeatures = hospital.whyUsFeatures || [];
      const featuresAreDental =
        savedFeatures.length > 0 &&
        DENTAL_FEATURE_TITLES.every((t) =>
          savedFeatures.some((f) => f.title === t),
        );
      const featuresToUse =
        savedFeatures.length === 0 || (type !== "dental" && featuresAreDental)
          ? DEFAULT_FEATURES_BY_TYPE[type] || DEFAULT_FEATURES_BY_TYPE.dental
          : savedFeatures;
      setWhyFeatures(featuresToUse);
      setWhyStats(statsToUse);

      // ✅ Use type-specific defaults if non-dental hospital has dental testimonials
      const savedTestimonials = hospital.testimonials || [];
      const testimonialsAreDental =
        savedTestimonials.length > 0 &&
        DENTAL_TESTIMONIAL_NAMES.every((n) =>
          savedTestimonials.some((t) => t.name === n),
        );
      const testimonialsToUse =
        savedTestimonials.length === 0 ||
        (type !== "dental" && testimonialsAreDental)
          ? SPECIALTY_TESTIMONIALS_BY_TYPE[type] ||
            SPECIALTY_TESTIMONIALS_BY_TYPE.dental
          : savedTestimonials;
      setTestimonials(testimonialsToUse);
    }
  }, [hospital]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.name.trim()) {
      showNotify("Error", "Hospital name is required.", true);
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ...form,
        tickerItems: form.tickerItems
          .split("\n")
          .map((s) => s.trim())
          .filter(Boolean),
        insurers: form.insurers
          .split("\n")
          .map((s) => s.trim())
          .filter(Boolean),
        whyUsFeatures: whyFeatures,
        whyUsStats: whyStats,
        testimonials,
      };
      await api.put("/hospital", payload);
      await refreshHospital();
      showNotify(
        "✅ Hospital Settings Saved!",
        "All changes are now live on the website.",
      );
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setSaving(false);
  };

  // ── Styles ──────────────────────────────────────────────────
  const inp = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 8,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    fontFamily: "DM Sans, sans-serif",
    outline: "none",
    background: "#f8fafc",
    boxSizing: "border-box",
    marginTop: 4,
  };
  const lbl = {
    fontSize: 12,
    fontWeight: 600,
    color: "#475569",
    display: "block",
    marginBottom: 2,
  };
  const fwrap = { marginBottom: 16 };
  const g2 = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 };
  const g3 = { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 };

  const sectionBtn = (id, label) => (
    <button
      onClick={() => setActiveSection(id)}
      style={{
        padding: "8px 16px",
        borderRadius: 8,
        border: "none",
        cursor: "pointer",
        fontSize: 13,
        fontWeight: 600,
        background: activeSection === id ? "#0d7377" : "#f1f5f9",
        color: activeSection === id ? "#fff" : "#374151",
        transition: "all 0.2s",
      }}
    >
      {label}
    </button>
  );

  return (
    <div>
      <div className="admin-section-title">🏥 Hospital Settings</div>
      <div className="admin-section-desc">
        Update your hospital details. Changes reflect instantly on the public
        website.
      </div>

      <div
        style={{
          display: "flex",
          gap: 8,
          flexWrap: "wrap",
          marginBottom: 24,
          marginTop: 16,
        }}
      >
        {sectionBtn("basic", "🏥 Basic Info")}
        {sectionBtn("stats", "📊 Stats")}
        {sectionBtn("ticker", "📢 Ticker")}
        {sectionBtn("whyus", "💡 Why Us")}
        {sectionBtn("testimonials", "⭐ Testimonials")}
        {sectionBtn("insurance", "🏦 Insurance")}
      </div>

      <div style={{ maxWidth: 700 }}>
        {/* ── BASIC INFO ────────────────────────────────────── */}
        {activeSection === "basic" && (
          <div>
            <div style={g2}>
              <div style={fwrap}>
                <label style={lbl}>
                  Hospital Name *
                  <span
                    style={{ fontWeight: 400, color: "#94a3b8", marginLeft: 6 }}
                  >
                    🔒 cannot be changed after registration
                  </span>
                </label>
                <input
                  style={{
                    ...inp,
                    background: "#f1f5f9",
                    color: "#94a3b8",
                    cursor: "not-allowed",
                  }}
                  type="text"
                  value={form.name}
                  disabled
                  title="Hospital name cannot be changed after registration."
                />
              </div>
              <div style={fwrap}>
                <label style={lbl}>Tagline / Type</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="e.g. Dental Hospital"
                  value={form.tagline}
                  onChange={(e) => set("tagline", e.target.value)}
                />
              </div>
            </div>
            <div style={g2}>
              <div style={fwrap}>
                <label style={lbl}>Phone Number *</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="+91 87936 08083"
                  value={form.phone}
                  onChange={(e) => set("phone", e.target.value)}
                />
              </div>
              <div style={fwrap}>
                <label style={lbl}>
                  WhatsApp{" "}
                  <span style={{ fontWeight: 400, color: "#94a3b8" }}>
                    (no + , with country code)
                  </span>
                </label>
                <input
                  style={inp}
                  type="text"
                  placeholder="918793608083"
                  value={form.whatsapp}
                  onChange={(e) => set("whatsapp", e.target.value)}
                />
              </div>
            </div>
            <div style={g2}>
              <div style={fwrap}>
                <label style={lbl}>Email Address</label>
                <input
                  style={inp}
                  type="email"
                  placeholder="care@hospital.in"
                  value={form.email}
                  onChange={(e) => set("email", e.target.value)}
                />
              </div>
              <div style={fwrap}>
                <label style={lbl}>Established Year</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="e.g. 2005"
                  value={form.established}
                  onChange={(e) => set("established", e.target.value)}
                />
              </div>
            </div>
            <div style={g2}>
              <div style={fwrap}>
                <label style={lbl}>Address</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="12, Dental Plaza, MG Road"
                  value={form.address}
                  onChange={(e) => set("address", e.target.value)}
                />
              </div>
              <div style={fwrap}>
                <label style={lbl}>City / State / Pincode</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="Pune, Maharashtra 411001"
                  value={form.city}
                  onChange={(e) => set("city", e.target.value)}
                />
              </div>
            </div>
            <div style={fwrap}>
              <label style={lbl}>
                Google Maps Link
                <span
                  style={{ fontWeight: 400, color: "#94a3b8", marginLeft: 6 }}
                >
                  (patients click "Get Directions" to open your location)
                </span>
              </label>
              <input
                style={inp}
                type="url"
                placeholder="https://maps.google.com/?q=Your+Hospital+Name+City"
                value={form.googleMapsUrl}
                onChange={(e) => set("googleMapsUrl", e.target.value)}
              />
              <div
                style={{
                  fontSize: 11,
                  color: "#64748b",
                  marginTop: 5,
                  lineHeight: 1.6,
                }}
              >
                💡 How to get your link: Open <strong>Google Maps</strong> →
                search your hospital → click <strong>Share</strong> → copy the
                link and paste here.
              </div>
              {form.googleMapsUrl && (
                <a
                  href={form.googleMapsUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    marginTop: 8,
                    background: "#f0fdf4",
                    border: "1px solid #86efac",
                    color: "#16a34a",
                    borderRadius: 8,
                    padding: "6px 14px",
                    fontSize: 12,
                    fontWeight: 600,
                    textDecoration: "none",
                  }}
                >
                  🗺️ Test Link — Opens in Google Maps
                </a>
              )}
            </div>
            <div style={fwrap}>
              <label style={lbl}>
                Logo URL{" "}
                <span style={{ fontWeight: 400, color: "#94a3b8" }}>
                  (paste image link or leave empty for 🦷)
                </span>
              </label>
              <input
                style={inp}
                type="url"
                placeholder="https://your-logo-url.com/logo.png"
                value={form.logoUrl}
                onChange={(e) => set("logoUrl", e.target.value)}
              />
              {form.logoUrl && (
                <img
                  src={form.logoUrl}
                  alt="Logo preview"
                  onError={(e) => (e.target.style.display = "none")}
                  style={{
                    marginTop: 8,
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #e2e8f0",
                  }}
                />
              )}
            </div>
            <div style={fwrap}>
              <label style={lbl}>
                Hospital Description{" "}
                <span style={{ fontWeight: 400, color: "#94a3b8" }}>
                  (shown in footer)
                </span>
              </label>
              <textarea
                style={{ ...inp, minHeight: 80, resize: "vertical" }}
                placeholder="e.g. Pune's most trusted healthcare centre offering expert care and advanced treatments."
                value={form.description}
                onChange={(e) => set("description", e.target.value)}
              />
            </div>
          </div>
        )}

        {/* ── STATS ─────────────────────────────────────────── */}
        {activeSection === "stats" && (
          <div>
            <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
              These stats appear on the Hero section and Why Us section of the
              main page.
            </div>
            <div style={g3}>
              <div style={fwrap}>
                <label style={lbl}>Happy Patients</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="18K+"
                  value={form.statPatients}
                  onChange={(e) => set("statPatients", e.target.value)}
                />
              </div>
              <div style={fwrap}>
                <label style={lbl}>Expert Doctors</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="20+"
                  value={form.statDoctors}
                  onChange={(e) => set("statDoctors", e.target.value)}
                />
              </div>
              <div style={fwrap}>
                <label style={lbl}>Avg Rating</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="4.9★"
                  value={form.statRating}
                  onChange={(e) => set("statRating", e.target.value)}
                />
              </div>
            </div>

            {/* ✅ Type-aware label for Why Us Stats */}
            <div
              style={{
                marginTop: 24,
                fontWeight: 700,
                fontSize: 13,
                color: "#0d7377",
                marginBottom: 4,
              }}
            >
              Why Us Stats (4 cards)
            </div>
            <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 12 }}>
              ✅ Pre-filled with defaults for your hospital type. Edit as
              needed.
            </div>
            {whyStats.map((s, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: 10,
                  marginBottom: 10,
                  alignItems: "center",
                }}
              >
                <input
                  style={{ ...inp, marginTop: 0, flex: 1 }}
                  placeholder="Number e.g. 18,000+"
                  value={s.num}
                  onChange={(e) => {
                    const arr = [...whyStats];
                    arr[i] = { ...arr[i], num: e.target.value };
                    setWhyStats(arr);
                  }}
                />
                <input
                  style={{ ...inp, marginTop: 0, flex: 2 }}
                  placeholder="Label e.g. Smiles Transformed"
                  value={s.label}
                  onChange={(e) => {
                    const arr = [...whyStats];
                    arr[i] = { ...arr[i], label: e.target.value };
                    setWhyStats(arr);
                  }}
                />
                <button
                  onClick={() =>
                    setWhyStats(whyStats.filter((_, j) => j !== i))
                  }
                  style={{
                    background: "#fef2f2",
                    border: "1px solid #fca5a5",
                    color: "#dc2626",
                    borderRadius: 6,
                    padding: "6px 10px",
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
            <button
              onClick={() => setWhyStats([...whyStats, { num: "", label: "" }])}
              style={{
                background: "#f1f5f9",
                border: "1px solid #d1d5db",
                borderRadius: 8,
                padding: "8px 16px",
                fontSize: 13,
                cursor: "pointer",
                color: "#374151",
              }}
            >
              + Add Stat
            </button>
          </div>
        )}

        {/* ── TICKER ────────────────────────────────────────── */}
        {activeSection === "ticker" && (
          <div>
            <div style={{ fontSize: 13, color: "#64748b", marginBottom: 4 }}>
              These items scroll across the ticker bar. One item per line.
            </div>
            <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 12 }}>
              ✅ Pre-filled with defaults for your hospital type. Edit as
              needed.
            </div>
            <div style={fwrap}>
              <label style={lbl}>
                Ticker Items{" "}
                <span style={{ fontWeight: 400, color: "#94a3b8" }}>
                  (one per line)
                </span>
              </label>
              <textarea
                style={{
                  ...inp,
                  minHeight: 200,
                  resize: "vertical",
                  fontFamily: "monospace",
                }}
                placeholder={
                  "Painless Procedures\nCosmetic Dentistry\nAward-Winning Care"
                }
                value={form.tickerItems}
                onChange={(e) => set("tickerItems", e.target.value)}
              />
            </div>
            <div style={{ fontSize: 12, color: "#94a3b8" }}>
              💡 Tip: Keep items short (2-4 words each) for best display.
            </div>
          </div>
        )}

        {/* ── WHY US ────────────────────────────────────────── */}
        {activeSection === "whyus" && (
          <div>
            <div style={g2}>
              <div style={fwrap}>
                <label style={lbl}>Section Tag</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="Why PearlSmile"
                  value={form.whyUsTitle}
                  onChange={(e) => set("whyUsTitle", e.target.value)}
                />
              </div>
              <div style={fwrap}>
                <label style={lbl}>Tagline</label>
                <input
                  style={inp}
                  type="text"
                  placeholder="Care You Can Trust Completely"
                  value={form.whyUsTagline}
                  onChange={(e) => set("whyUsTagline", e.target.value)}
                />
              </div>
            </div>
            <div style={fwrap}>
              <label style={lbl}>Description</label>
              <textarea
                style={{ ...inp, minHeight: 72, resize: "vertical" }}
                placeholder="We combine advanced technology..."
                value={form.whyUsDesc}
                onChange={(e) => set("whyUsDesc", e.target.value)}
              />
            </div>
            <div
              style={{
                fontWeight: 700,
                fontSize: 13,
                color: "#0d7377",
                margin: "16px 0 10px",
              }}
            >
              Feature Items
            </div>
            {whyFeatures.map((f, i) => (
              <div
                key={i}
                style={{
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: 10,
                  padding: 14,
                  marginBottom: 12,
                }}
              >
                <div style={{ display: "flex", gap: 10, marginBottom: 8 }}>
                  <input
                    style={{ ...inp, marginTop: 0, width: 60 }}
                    placeholder="🏆"
                    value={f.icon}
                    onChange={(e) => {
                      const arr = [...whyFeatures];
                      arr[i] = { ...arr[i], icon: e.target.value };
                      setWhyFeatures(arr);
                    }}
                  />
                  <input
                    style={{ ...inp, marginTop: 0, flex: 1 }}
                    placeholder="Feature Title"
                    value={f.title}
                    onChange={(e) => {
                      const arr = [...whyFeatures];
                      arr[i] = { ...arr[i], title: e.target.value };
                      setWhyFeatures(arr);
                    }}
                  />
                  <button
                    onClick={() =>
                      setWhyFeatures(whyFeatures.filter((_, j) => j !== i))
                    }
                    style={{
                      background: "#fef2f2",
                      border: "1px solid #fca5a5",
                      color: "#dc2626",
                      borderRadius: 6,
                      padding: "6px 10px",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                  >
                    ✕
                  </button>
                </div>
                <textarea
                  style={{
                    ...inp,
                    marginTop: 0,
                    minHeight: 56,
                    resize: "vertical",
                  }}
                  placeholder="Feature description..."
                  value={f.desc}
                  onChange={(e) => {
                    const arr = [...whyFeatures];
                    arr[i] = { ...arr[i], desc: e.target.value };
                    setWhyFeatures(arr);
                  }}
                />
              </div>
            ))}
            <button
              onClick={() =>
                setWhyFeatures([
                  ...whyFeatures,
                  { icon: "", title: "", desc: "" },
                ])
              }
              style={{
                background: "#f1f5f9",
                border: "1px solid #d1d5db",
                borderRadius: 8,
                padding: "8px 16px",
                fontSize: 13,
                cursor: "pointer",
                color: "#374151",
              }}
            >
              + Add Feature
            </button>
          </div>
        )}

        {/* ── TESTIMONIALS ──────────────────────────────────── */}
        {activeSection === "testimonials" && (
          <div>
            <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
              Manage patient reviews shown on the main page.
            </div>
            {testimonials.map((t, i) => (
              <div
                key={i}
                style={{
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: 10,
                  padding: 14,
                  marginBottom: 12,
                }}
              >
                <div style={{ display: "flex", gap: 10, marginBottom: 8 }}>
                  <input
                    style={{ ...inp, marginTop: 0, width: 60 }}
                    placeholder="A"
                    value={t.init}
                    onChange={(e) => {
                      const arr = [...testimonials];
                      arr[i] = { ...arr[i], init: e.target.value };
                      setTestimonials(arr);
                    }}
                  />
                  <input
                    style={{ ...inp, marginTop: 0, flex: 1 }}
                    placeholder="Patient Name"
                    value={t.name}
                    onChange={(e) => {
                      const arr = [...testimonials];
                      arr[i] = { ...arr[i], name: e.target.value };
                      setTestimonials(arr);
                    }}
                  />
                  <button
                    onClick={() =>
                      setTestimonials(testimonials.filter((_, j) => j !== i))
                    }
                    style={{
                      background: "#fef2f2",
                      border: "1px solid #fca5a5",
                      color: "#dc2626",
                      borderRadius: 6,
                      padding: "6px 10px",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                  >
                    ✕
                  </button>
                </div>
                <input
                  style={{ ...inp, marginTop: 0, marginBottom: 8 }}
                  placeholder="Role e.g. Software Engineer, Pune"
                  value={t.role}
                  onChange={(e) => {
                    const arr = [...testimonials];
                    arr[i] = { ...arr[i], role: e.target.value };
                    setTestimonials(arr);
                  }}
                />
                <textarea
                  style={{
                    ...inp,
                    marginTop: 0,
                    minHeight: 72,
                    resize: "vertical",
                  }}
                  placeholder="Patient review..."
                  value={t.quote}
                  onChange={(e) => {
                    const arr = [...testimonials];
                    arr[i] = { ...arr[i], quote: e.target.value };
                    setTestimonials(arr);
                  }}
                />
              </div>
            ))}
            <button
              onClick={() =>
                setTestimonials([
                  ...testimonials,
                  { init: "", name: "", role: "", quote: "", stars: "★★★★★" },
                ])
              }
              style={{
                background: "#f1f5f9",
                border: "1px solid #d1d5db",
                borderRadius: 8,
                padding: "8px 16px",
                fontSize: 13,
                cursor: "pointer",
                color: "#374151",
              }}
            >
              + Add Review
            </button>
          </div>
        )}

        {/* ── INSURANCE ─────────────────────────────────────── */}
        {activeSection === "insurance" && (
          <div>
            <div style={fwrap}>
              <label style={lbl}>Section Title</label>
              <input
                style={inp}
                type="text"
                placeholder="We Accept All Major Insurance Plans"
                value={form.insuranceTitle}
                onChange={(e) => set("insuranceTitle", e.target.value)}
              />
            </div>
            <div style={fwrap}>
              <label style={lbl}>Description</label>
              <textarea
                style={{ ...inp, minHeight: 72, resize: "vertical" }}
                placeholder="Cashless treatment available..."
                value={form.insuranceDesc}
                onChange={(e) => set("insuranceDesc", e.target.value)}
              />
            </div>
            <div style={fwrap}>
              <label style={lbl}>
                Insurance Companies{" "}
                <span style={{ fontWeight: 400, color: "#94a3b8" }}>
                  (one per line)
                </span>
              </label>
              <textarea
                style={{
                  ...inp,
                  minHeight: 160,
                  resize: "vertical",
                  fontFamily: "monospace",
                }}
                placeholder={"Star Health\nNew India\nHDFC ERGO\nICICI Lombard"}
                value={form.insurers}
                onChange={(e) => set("insurers", e.target.value)}
              />
            </div>
          </div>
        )}

        {/* Save Button */}
        <div
          style={{
            marginTop: 24,
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          <button
            onClick={handleSave}
            disabled={saving}
            style={{
              background: saving
                ? "#94a3b8"
                : "linear-gradient(135deg,#0d7377,#14a0a5)",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "13px 32px",
              fontSize: 14,
              fontWeight: 700,
              cursor: saving ? "not-allowed" : "pointer",
              fontFamily: "DM Sans, sans-serif",
              transition: "opacity 0.2s",
            }}
          >
            {saving ? "Saving..." : "💾 Save Hospital Settings"}
          </button>
          <div style={{ fontSize: 11, color: "#94a3b8" }}>
            ✅ Changes reflect instantly on website — no rebuild needed.
          </div>
        </div>
      </div>
    </div>
  );
}
